module.exports = __webpack_public_path__ + "img/icon-charts.a9c123c8.svg";